import { authPost } from "../../common/redux/ApiClient";

const baseUrl = "http://35.240.204.237/ok99memberApi/api";

export function fetchLiveCasinoPageUI(params) {
  return authPost(`${baseUrl}/MemberPc1/PcLivePageUI`, params);
}

export function fetchLiveCasinoGameList(params) {
  return authPost(`${baseUrl}/MemberPc1/PcLiveGameList`, params);
}

export function companyPlayGame(params) {
  return authPost(`${baseUrl}/Member3/CompanyPlayGame`, params);
}
